'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _core = require('@aws-amplify/core');

var _auth = require('@aws-amplify/auth');

var _auth2 = _interopRequireDefault(_auth);

var _AuthPiece2 = require('./AuthPiece');

var _AuthPiece3 = _interopRequireDefault(_AuthPiece2);

var _AmplifyUIComponentsReact = require('../Amplify-UI/Amplify-UI-Components-React');

var _countryDialCodes = require('./common/country-dial-codes.js');

var _countryDialCodes2 = _interopRequireDefault(_countryDialCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

var SignUp = function (_AuthPiece) {
    (0, _inherits3.default)(SignUp, _AuthPiece);

    function SignUp(props) {
        (0, _classCallCheck3.default)(this, SignUp);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SignUp.__proto__ || Object.getPrototypeOf(SignUp)).call(this, props));

        _this._validAuthStates = ['signUp'];
        _this.signUp = _this.signUp.bind(_this);

        _this.inputs = {
            dial_code: "+1"
        };
        return _this;
    }

    (0, _createClass3.default)(SignUp, [{
        key: 'signUp',
        value: function signUp() {
            var _this2 = this;

            var _inputs = this.inputs,
                username = _inputs.username,
                password = _inputs.password,
                email = _inputs.email,
                dial_code = _inputs.dial_code,
                phone_line_number = _inputs.phone_line_number;

            if (!_auth2.default || typeof _auth2.default.signUp !== 'function') {
                throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
            }

            var phone_number = null;
            if (dial_code && phone_line_number) {
                phone_number = dial_code + phone_line_number;
            }

            _auth2.default.signUp({
                username: username,
                password: password,
                attributes: {
                    email: email,
                    phone_number: phone_number
                }
            }).then(function () {
                return _this2.changeState('confirmSignUp', username);
            }).catch(function (err) {
                return _this2.error(err);
            });
        }
    }, {
        key: 'showComponent',
        value: function showComponent(theme) {
            var _this3 = this;

            var hide = this.props.hide;

            if (hide && hide.includes(SignUp)) {
                return null;
            }

            // console.log(countryDialCodes.sort());

            return _react2.default.createElement(
                _AmplifyUIComponentsReact.FormSection,
                { theme: theme },
                _react2.default.createElement(
                    _AmplifyUIComponentsReact.SectionHeader,
                    { theme: theme },
                    _core.I18n.get('Create a new account')
                ),
                _react2.default.createElement(
                    _AmplifyUIComponentsReact.SectionBody,
                    { theme: theme },
                    _react2.default.createElement(
                        _AmplifyUIComponentsReact.FormField,
                        { theme: theme },
                        _react2.default.createElement(
                            _AmplifyUIComponentsReact.InputLabel,
                            null,
                            _core.I18n.get('Username'),
                            ' *'
                        ),
                        _react2.default.createElement(_AmplifyUIComponentsReact.Input, {
                            autoFocus: true,
                            placeholder: _core.I18n.get('Create a username'),
                            theme: theme,
                            key: 'username',
                            name: 'username',
                            onChange: this.handleInputChange
                        })
                    ),
                    _react2.default.createElement(
                        _AmplifyUIComponentsReact.FormField,
                        { theme: theme },
                        _react2.default.createElement(
                            _AmplifyUIComponentsReact.InputLabel,
                            null,
                            _core.I18n.get('Password'),
                            ' *'
                        ),
                        _react2.default.createElement(_AmplifyUIComponentsReact.Input, {
                            placeholder: _core.I18n.get('Create a password'),
                            theme: theme,
                            type: 'password',
                            key: 'password',
                            name: 'password',
                            onChange: this.handleInputChange
                        })
                    ),
                    _react2.default.createElement(
                        _AmplifyUIComponentsReact.FormField,
                        { theme: theme },
                        _react2.default.createElement(
                            _AmplifyUIComponentsReact.InputLabel,
                            null,
                            _core.I18n.get('Email Address'),
                            ' *'
                        ),
                        _react2.default.createElement(_AmplifyUIComponentsReact.Input, {
                            placeholder: 'janedoe@email.com',
                            theme: theme,
                            key: 'email',
                            name: 'email',
                            onChange: this.handleInputChange
                        })
                    ),
                    _react2.default.createElement(
                        _AmplifyUIComponentsReact.FormField,
                        { theme: theme },
                        _react2.default.createElement(
                            _AmplifyUIComponentsReact.InputLabel,
                            null,
                            _core.I18n.get('Phone Number')
                        ),
                        _react2.default.createElement(
                            _AmplifyUIComponentsReact.SelectInput,
                            { theme: theme },
                            _react2.default.createElement(
                                'select',
                                { key: 'dial_code', name: 'dial_code', defaultValue: '+1', onChange: this.handleInputChange },
                                _countryDialCodes2.default.map(function (dialCode) {
                                    return _react2.default.createElement(
                                        'option',
                                        { key: dialCode, value: dialCode },
                                        dialCode
                                    );
                                })
                            ),
                            _react2.default.createElement(_AmplifyUIComponentsReact.Input, {
                                placeholder: '555-555-1212',
                                theme: theme,
                                key: 'phone_line_number',
                                name: 'phone_line_number',
                                onChange: this.handleInputChange
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    _AmplifyUIComponentsReact.SectionFooter,
                    { theme: theme },
                    _react2.default.createElement(
                        _AmplifyUIComponentsReact.SectionFooterPrimaryContent,
                        { theme: theme },
                        _react2.default.createElement(
                            _AmplifyUIComponentsReact.Button,
                            { onClick: this.signUp, theme: theme },
                            _core.I18n.get('Create Account')
                        )
                    ),
                    _react2.default.createElement(
                        _AmplifyUIComponentsReact.SectionFooterSecondaryContent,
                        { theme: theme },
                        _core.I18n.get('Have an account? '),
                        _react2.default.createElement(
                            _AmplifyUIComponentsReact.Link,
                            { theme: theme, onClick: function onClick() {
                                    return _this3.changeState('signIn');
                                } },
                            _core.I18n.get('Sign in')
                        )
                    )
                )
            );
        }
    }]);
    return SignUp;
}(_AuthPiece3.default);

exports.default = SignUp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-amplify-react/dist/Auth/SignUp.js
// module id = 635
// module chunks = 0